import { Injectable, OnInit } from '@angular/core';
import { DealerResponse, SearchDealersRequest } from '../models/pudo';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiProvider } from '../providers/api.provider';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PudoService implements OnInit {

  private requestHeaders2: HttpHeaders = new HttpHeaders()
    .append('Access-Control-Allow-Origin', '*')
    .append('Access-Control-Allow-Methods', 'GET,HEAD,OPTIONS,POST,PUT')
    .append(
      'Access-Control-Allow-Headers',
      'Origin, Content-Type, X-Auth-Token'
    );


  private currentPudoSubject: BehaviorSubject<DealerResponse>;
  public currentPudo: Observable<DealerResponse>;
  constructor(private http: HttpClient,) {

     }

  ngOnInit() {
    this.http.post<boolean>('https://testpartnerapi.pudoinc.com', '', {
      headers: this.requestHeaders2
    });
  }

  public get currentRouteValue(): DealerResponse {
    return this.currentPudoSubject.value;
  }

  async initialiseDealers(postalCode: string) {
    this.http.post<boolean>('https://testpartnerapi.pudoinc.com', '', {
      headers: this.requestHeaders2
    });
    let searchDealersRequest = new SearchDealersRequest();
    searchDealersRequest.partnerCode = 'NationexT';
    searchDealersRequest.partnerPassword = 'NaT2020x#';
    searchDealersRequest.address = postalCode;
    this.PudoSearchReturnTo(searchDealersRequest).subscribe(
      DealerResponse => {
        this.currentPudoSubject.next(DealerResponse);
      }
    );
/*
    await this.apiProvider.GetRoute(postalCode).subscribe((route: DealerResponse) => {
      this.currentPudoSubject = new BehaviorSubject<DealerResponse>(route);
      this.currentPudo = this.currentPudoSubject.asObservable();
    }, (err: HttpErrorResponse) => {
      this.currentPudoSubject.next(null);
    });*/
  }

  public PudoSearchReturnTo(
    searchDealersRequest: SearchDealersRequest
  ): Observable<DealerResponse> {
    const url = 'https://testpartnerapi.pudoinc.com/PUDOService.svc/SearchReturnTo';
    const response = this.http.post<DealerResponse>(url, searchDealersRequest);
    return response;
  }
}
